import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ProductGroupPopupComponent } from './product-group-popup/product-group-popup.component';
import { ProductsAssignedToRolesService } from 'src/app/shared/services/products-assigned-to-roles.service';
import { ColDef, GridApi, GridReadyEvent, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridActionbutton } from 'src/app/shared/common/AgGridActionbutton';
import { GenericBadgeRendererComponent } from 'src/app/shared/common/generic-badge-renderer.component';

@Component({
    selector: 'app-product-group-product-mapping',
    templateUrl: './product-group-product-mapping.component.html',
    styleUrls: ['./product-group-product-mapping.component.scss'],
    standalone: false
})
export class ProductGroupProductMappingComponent implements OnInit {
 gridApi!: GridApi;

  productGroups: any[] = [];
  filteredProductGroups: any[] = [];

  selectedProductGroup: any = null;

  rowData: any[] = [];
  filteredRowData: any[] = [];

  productGroupSearchText = '';
  productSearchText = '';
  assignmentFilter = 'ALL';

  columnDefs: ColDef[] = [];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      }
  };
components: any={
          buttonRenderer: AgGridActionbutton
        }
selectedProducts:any=[];

pageSize = 50;
  currentPage:any = 1;
  totalPages = 1;
  totalRows = 0;
  startRow = 1;
  endRow = 50;

  constructor( 
      private dialog: MatDialog,
      private spinner: NgxUiLoaderService,
      private snackbar: MatSnackBar,
      private localStorageSettings: LocalStorageSettingsService,
      private services:ProductsAssignedToRolesService
  ) { }

  ngOnInit(): void {
    this.columnDefs=[
       {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
      pinned: 'left',
      lockPosition: true
    },
    { 
      headerName: 'ID', 
      headerTooltip:'ID',
      field: 'id',
      sortable: true,
      tooltipValueGetter: (params) => 'ID : ' + params.value,
      filter: 'agTextColumnFilter'
    },
     { 
      headerName: 'Name', 
      headerTooltip:'Name',
      field: 'name__v',
      sortable: true,
      tooltipValueGetter: (params) => 'Name : ' + params.value,
      filter: 'agTextColumnFilter'
    },
    { 
      headerName: 'Mapping', 
      headerTooltip:'Mapping',
      field: 'assigned',
      sortable: true,
      tooltipValueGetter: (params) => {
        return params.value ? 'Mapping: Mapped' : 'Mapping: Not mapped';
      },
       cellRenderer: GenericBadgeRendererComponent,
        cellRendererParams: { type: 'MAPPING_RULE' },

        // Custom filter value getter to ensure filtering works based on the displayed badge value
        filterValueGetter: (params: any) => {
          const v = (params.data?.mapping || '').toLowerCase();

          if (v === 'auto') return 'A Auto';
          if (v === 'manual') return 'M Manual';
          return 'NM Not Mapped';
        }
    },
     { 
      headerName: 'Type', 
      headerTooltip:'Type',
      field: 'object_type__v_name__v',
      sortable: true,
      tooltipValueGetter: (params) => 'Type : ' + params.value,
      filter: 'agTextColumnFilter'
    },
    { 
      headerName: 'Product Family', 
      headerTooltip:'Product Family',
      field: 'product_family__v_name__v',
      sortable: true,
      tooltipValueGetter: (params) => 'Product Family : ' + params.value,
      filter: 'agTextColumnFilter'
    },
    { 
      headerName: 'Life Cycle', 
      headerTooltip:'Life Cycle',
      field: 'lifecycle__v',
      sortable: true,
      tooltipValueGetter: (params) => 'Life Cycle : ' + params.value,
      filter: 'agTextColumnFilter'
    },
    { 
      headerName: 'Organization Name', 
      headerTooltip:'Organization Name',
      field: 'organization__v_name__v',
      sortable: true,
      tooltipValueGetter: (params) => 'Organization Name : ' + params.value,
      filter: 'agTextColumnFilter'
    },
    { 
      headerName: 'Status', 
      headerTooltip:'Status',
      field: 'status__v',
      sortable: true,
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      filter: 'agTextColumnFilter'
    }
    ]
   this.loadProductGroups()
  }

   goToFirst() {
    this.gridApi?.paginationGoToFirstPage();
    this.onPageChange();
  }

  goToPrevious() {
    this.gridApi?.paginationGoToPreviousPage();
    this.onPageChange();
  }

  goToNext() {
    this.gridApi?.paginationGoToNextPage();
    this.onPageChange();
  }

  goToLast() {
    this.gridApi?.paginationGoToLastPage();
    this.onPageChange();
  }

  onPageChange() {
    let currentpage:any = this.gridApi?.paginationGetCurrentPage();
    this.currentPage=currentpage+1
    if(this.currentPage != this.gridApi?.paginationGetTotalPages()){
      this.startRow = currentpage * this.pageSize +1;
      this.endRow = this.startRow + this.pageSize - 1;
    }else{
        this.startRow = currentpage * this.pageSize +1;
        this.endRow = this.totalRows;
    }
  }

  loadProductGroups(): void {
     this.spinner.start()
    this.services.retrieveProductGroupList().subscribe(res=>{
      if(res.error){
      this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", {
            duration: 5000,
          });
      }else{
        console.log(res);
        let data:any=res
         this.productGroups =data
         this.filteredProductGroups = [...this.productGroups];

        if (this.filteredProductGroups.length > 0) {
          this.onProductGroupSelect(this.filteredProductGroups[0]);
        }
        this.spinner.stop()
      }
    })

    
  }
  onRefresh(){

  }

  onCreateProductGroup(){
     let dialogRef = this.dialog.open(ProductGroupPopupComponent, {
            width: "35%",
            autoFocus: false,
            height: "35%",
            disableClose: true,
            data: {},
          });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if(result == 1){
           this.loadProductGroups()
        }
      });
  }

    onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
  }

  filterProductGroups(): void {
    const search = this.productGroupSearchText?.toLowerCase()?.trim();

    if (!search) {
      this.filteredProductGroups = [...this.productGroups];
      return;
    }
console.log(this.productGroups);
console.log(search);

    this.filteredProductGroups = this.productGroups.filter(group =>
      group.productGroupName?.toLowerCase().includes(search)
    );
  }

  onProductGroupSelect(group: any): void {
    console.log(group);
    
    this.selectedProductGroup = group;
    this.productSearchText = '';
    this.assignmentFilter = 'ALL';
    this.loadProductsByProductGroup(group.productGroupId);
  }

  loadProductsByProductGroup(productGroupId: any): void {
    // Replace with actual API call
    // this.service.getProductsByProductGroup(productGroupId).subscribe(res => { ... });
// this.service.retrieveProductListByProductGroupId

 this.spinner.start()
    this.services.retrieveProductListByProductGroupId(productGroupId).subscribe(res=>{
      if(res.error){
      this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", {
            duration: 5000,
          });
      }else{
        console.log(res);
        let data:any=res
         this.rowData =data
           this.totalRows = this.rowData.length;

          this.totalPages = Math.ceil(this.totalRows / this.pageSize);

           // Update display values
        this.startRow = ((this.currentPage - 1) * this.pageSize) + 1;
        this.endRow = Math.min(this.currentPage * this.pageSize, this.totalRows);
        this.applyProductFilter();

    setTimeout(() => {
      if (!this.gridApi) return;

      this.gridApi.deselectAll();
      this.gridApi.forEachNode(node => {
        if (node.data?.assigned === true) {
          node.setSelected(true);
        }
      });
    }, 100);
        this.spinner.stop()
      }
    })

    
  }

  applyProductFilter(): void {
    const search = this.productSearchText?.toLowerCase()?.trim();
console.log(search);

    this.filteredRowData = this.rowData.filter(row => {
      const matchesSearch =
        !search ||
        row.name__v?.toLowerCase().includes(search) ||
        row.generic_name__v?.toLowerCase().includes(search) ||
        row.product_family__v_name__v?.toLowerCase().includes(search);

      const matchesAssignment =
        this.assignmentFilter === 'ALL' ||
        (this.assignmentFilter === 'MAPPED' && row.assigned) ||
        (this.assignmentFilter === 'UNMAPPED' && !row.assigned);

      return matchesSearch && matchesAssignment;
    });

    setTimeout(() => {
      if (!this.gridApi) return;

      this.gridApi.deselectAll();
      this.gridApi.forEachNode(node => {
        if (node.data?.assigned === true) {
          node.setSelected(true);
        }
      });
    }, 100);
  }

  resetSelection(): void {
    if (!this.selectedProductGroup) return;
    this.loadProductsByProductGroup(this.selectedProductGroup.productGroupId);
  }

  saveMapping(): void {
    if (!this.selectedProductGroup || !this.gridApi) return;

    const selectedProductIds: string[] = [];
    this.gridApi.getSelectedNodes().forEach(node => {
      if (node.data?.id) {
        selectedProductIds.push(node.data.id);
      }
    });

    const payload = {
      productGroupId: this.selectedProductGroup.productGroupId,
      productIds: selectedProductIds,
      updatedBy: 'currentUser'
    };

    console.log('Save payload:', payload);

    // Replace with API call
    // this.service.saveProductGroupProducts(payload).subscribe(res => { ... });
  }

  onSelectionChanged(event: SelectionChangedEvent): void {
          this.selectedProducts = event.api.getSelectedRows();
          console.log(this.selectedProducts);
          
  }

  onAssignSelectedProducts(){
      const selectedProductsIds = this.selectedProducts.map(item => item.id);
        let insertProductsObject={
          product_group_id:this.selectedProductGroup.productGroupId,
          productid:selectedProductsIds
        }
        this.spinner.start();
       this.services.insertProductsByProductGroupId(insertProductsObject).subscribe(response => {
      console.log(response);

      if (response.error == true) {

        this.spinner.stop();

        this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });


      } else {
        console.log(response);
        
         this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
        this.spinner.stop();

      }
    });

  }
}
